// import React from "react";
// import { miscFields } from "../formFields.js/PurchaseOrderFields";
// import CommonFormTab from "./CommonFormTab";

// export default function MiscTab({ formData, onChange, readOnly, formSubmissionAttempted }) {
//   return (
//     <CommonFormTab
//       fields={miscFields}
//       formData={formData}
//       onChange={onChange}
//       readOnly={readOnly}
//       formSubmissionAttempted={formSubmissionAttempted}
//     />
//   );
// }




import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { miscFields } from "../formFields.js/PurchaseOrderFields";
import CommonFormTab from "./CommonFormTab";

/**
 * MiscTab
 *
 * Auto-fills createByUser and editedByUser from redux.userDetail when creating a PO.
 *
 * Props:
 *  - formData, onChange, readOnly, formSubmissionAttempted
 *  - mode (optional): 'create'|'edit'|'view' -> if not provided it will infer from formData
 */
export default function MiscTab({
  formData = {},
  onChange,
  readOnly = false,
  formSubmissionAttempted = false,
  mode,
}) {
  const prefilledRef = useRef(false);
  const reduxUser = useSelector((state) => state.login?.userDetail);

  // infer mode when parent didn't pass it
  const inferredMode =
    mode ||
    (formData && (formData.id || formData._id || formData.purchaseOrder) ? "edit" : "create");

  useEffect(() => {
    // Only auto-fill on create, only when not readonly, and only once
    if (prefilledRef.current) return;
    if (readOnly) return;
    if (inferredMode !== "create") return;

    // Guard: if no onChange or no redux user, skip
    if (typeof onChange !== "function") {
      prefilledRef.current = true;
      return;
    }
    if (!reduxUser) {
      prefilledRef.current = true;
      return;
    }

    // Resolve a sensible display name from userDetail
    const resolvedName =
      reduxUser?.name ||
      reduxUser?.fullName ||
      reduxUser?.username ||
      reduxUser?.userName ||
      reduxUser?.email ||
      reduxUser?.id ||
      "";

    const patches = {};
    let changed = false;

    // Only set if empty/undefined
    if (!formData?.createByUser || String(formData.createByUser).trim() === "") {
      patches.createByUser = resolvedName;
      changed = true;
    }
    // if (!formData?.editedByUser || String(formData.editedByUser).trim() === "") {
    //   patches.editedByUser = resolvedName;
    //   changed = true;
    // }

    if (changed) {
      Object.entries(patches).forEach(([name, value]) => {
        onChange({ target: { name, value } });
      });
    }

    prefilledRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inferredMode, readOnly, onChange, reduxUser]);

  return (
    <CommonFormTab
      fields={miscFields}
      formData={formData}
      onChange={onChange}
      readOnly={readOnly}
      formSubmissionAttempted={formSubmissionAttempted}
      mode={inferredMode}
    />
  );
}
